/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'plan-long-term-growth-48x48': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<defs><path pid="0" id="svgicon_plan-long-term-growth-48x48_a" d="M0 .53h48v48H0z"/></defs><g transform="translate(0 -.53)" _fill="none" fill-rule="evenodd"><mask id="svgicon_plan-long-term-growth-48x48_b" _fill="#fff"><use xlink:href="#svgicon_plan-long-term-growth-48x48_a"/></mask><g mask="url(#svgicon_plan-long-term-growth-48x48_b)" _stroke="#181818" stroke-width="2"><path pid="1" d="M40.512 3.57L25.08 6.707a19.868 19.868 0 00-13.411 9.823 23.11 23.11 0 00-2.205 16.873l1.685 6.683h0v.962h12.91a18.625 18.625 0 0015.474-8.259 23.377 23.377 0 003.422-17.974L40.512 3.57h0z" stroke-linejoin="round"/><path pid="2" d="M34.504 14.054S21.584 37.06 3 45.536" stroke-linecap="round" stroke-linejoin="round"/><path pid="3" stroke-linecap="round" d="M19.501 20.035v13.246M26.232 26.094l6.777-.055"/></g></g>'
  }
})
